import { render, staticRenderFns } from "./404.vue?vue&type=template&id=09c68b87&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=09c68b87&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c68b87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c68b87')) {
      api.createRecord('09c68b87', component.options)
    } else {
      api.reload('09c68b87', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=09c68b87&scoped=true", function () {
      api.rerender('09c68b87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/404.vue"
export default component.exports